(function($) {
    $(document).ready(function() {
        if ($('.fishing-premium-pass-content.lite-functionality').length > 0) return;

        const fishingContent = $('.fishing-premium-pass-content');
        if (fishingContent.length === 0) {
            return; // Abandon this hook if target does not exist
        }

        function launched() {
            const date = new Date();
            // EST date of launch: 2022-04-18 18:00:00
            // UTC date of launch: 2022-04-18 22:00:00
            if (date.getUTCFullYear() > 2022 || date.getUTCMonth() > 3 || date.getUTCDate() > 18) return true;
            return (date.getUTCFullYear() === 2022 && date.getUTCMonth() === 3 && date.getUTCDate() === 18 && date.getUTCHours() >= 22);
        }

        let intervalId = window.setInterval(function(){
            if (launched()) {
                maybeEnableAddToCart();
                clearInterval(intervalId);
            }
        }, 1000);

        let calendarMemo = {};
        function getAvailability(monthYear) {
            if (monthYear in calendarMemo) {
                updateCalendar(monthYear);
                return;
            }

            $.ajax({
                url: wpApiSettings.root + wpApiSettings.namespace + '/fishing-pass/availability/'+monthYear,
                type: "GET",
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('X-WP-Nonce', wpApiSettings.nonce);
                }
            }).done(function(r) {
                if (r !== undefined && monthYear in r) {
                    calendarMemo[monthYear] = r[monthYear];
                    updateCalendar(monthYear);
                }
            });
        }

        function updateCalendar(monthYear) {
            $('td.bookable').addClass('ui-datepicker-unselectable ui-state-disabled');
            $.each(calendarMemo[monthYear], function(date, availability) {
                availability = availability['premium'];
                if (availability === false) return;
                let ymd = date.split('-');
                let year = ymd[0];
                let month = ymd[1]-1;
                let day = ymd[2];
                let cell = $('td[data-month="'+month+'"][data-year="'+year+'"] > a').filter(function() {
                    return parseInt($(this).text()) === parseInt(day);
                });
                if (availability > 0) {
                    cell.parent().removeClass('ui-datepicker-unselectable ui-state-disabled');
                }

                if (availability <= 0) {
                    availability = 'SOLD OUT';
                } else {
                    availability = availability + ' PASSES';
                }

                cell.parent().css('position', 'relative');
                cell.parent().append("<span style='position:absolute;top:50%;height:auto;width:100%;text-align:center!important;z-index:1;'>"+availability+"</span>");
            });
            $(document).trigger('availability_updated');
        }

        let currentDate = null;
        let timer;
        function debounceQuery() {
            clearTimeout(timer);
            timer = setTimeout(function() {
                if ($('.picker > .blockUI').length <= 0) {
                    let month = $('.ui-datepicker-title > .ui-datepicker-month').text();
                    let year = $('.ui-datepicker-title > .ui-datepicker-year').text();
                    if (month && year) {
                        currentDate = month + ' ' + year;
                        getAvailability(currentDate);
                    }
                } else {
                    debounceQuery();
                }
            }, 500);
        }
        $('fieldset.wc-bookings-date-picker').on('DOMSubtreeModified', '.picker', function(){
            debounceQuery()
        });
        $('.ui-datepicker-calendar td').click(function() {
            currentDate = null;
        });

        const bookingForm = $('form.wc-bookings-booking-form');

        // These are visible form fields for choosing a fishing day pass
        const bookingStartDate = $('input#booking-start-date');
        const numDays = $('select#num-days');
        const numGuests = $('select#num-guests');
        const guestCategory = $('select#guest-category');

        const partyName = $('input#party-name');
        const partyNameLabel = $("label#party-name-label");

        const guideName = $('select#guide-name');
        const guideNameLabel = $("label#guide-name-label");

        const confirmationModal = $('div#confirmPremiumPassModal');
        const confirmAddToCart = $('button#confirm-add-to-cart');
        const addToCart = $('button#btn-add-to-cart');

        // These are hidden form fields behind the calendar UI
        const checkInYear = $('input[name="wc_bookings_field_start_date_year"]');
        const checkInMonth = $('input[name="wc_bookings_field_start_date_month"]');
        const checkInDay = $('input[name="wc_bookings_field_start_date_day"]');
        const stayDuration = $('input[name="wc_bookings_field_duration"]');
        const numPersons = $('input[name="wc_bookings_field_persons"]');

        const handleStartDateChange = function() {
            let dateParts = bookingStartDate.val().split('-');

            let year = dateParts[0];
            let month = dateParts[1];
            let day = dateParts[2];

            checkInYear.val(year);
            checkInMonth.val(month);
            checkInDay.val(day);
            stayDuration.trigger('change');
        }
        bookingStartDate.change(handleStartDateChange)

        const handleNumDaysChange = function() {
            stayDuration.val($(this).val());
            stayDuration.trigger('change');
        }
        numDays.change(handleNumDaysChange);

        const handleNumGuestsChange = function() {
            numPersons.val($(this).val());
            numPersons.trigger('change');
        }
        numGuests.change(handleNumGuestsChange);

        /**
         * This event fires when the user clicks on a date on the calendar
         */
        const handleCalendarDateChange = function() {
            bookingStartDate.val(checkInYear.val() + '-' + checkInMonth.val() + '-' + checkInDay.val());
        }
        checkInYear.change(handleCalendarDateChange);
        checkInMonth.change(handleCalendarDateChange);
        checkInDay.change(handleCalendarDateChange);

        stayDuration.change(function() {
            numDays.val($(this).val());
        });

        const maybeEnableAddToCart = function() {
            let cost = $(document).find('.cost-container > .woocommerce-Price-amount');
            let should_enable = true;

            should_enable &= launched();
            should_enable &= cost.length > 0;
            should_enable &= guestCategory.val() != '';
            should_enable &= partyName.val() != '' || guideName.val() != '';

            if (!should_enable) {
                addToCart.addClass('disabled');
            } else {
                addToCart.removeClass('disabled');
            }
        };
        maybeEnableAddToCart();

        const guestCategoryChange = function() {
            if (guestCategory.val() == 'Guided Client') {
                partyName.val('');
                partyName.hide();
                partyNameLabel.hide();
                guideNameLabel.show();
                guideName.show();
            } else {
                guideName.val('');
                guideName.hide();
                guideNameLabel.hide();
                partyNameLabel.show();
                partyName.show();
            }

            maybeEnableAddToCart();
        };

        const submitForm = function(e) {
            e.preventDefault();

            if (addToCart.hasClass('disabled')) {
                return;
            }

            $.blockUI({message: null});

            var d = moment(bookingStartDate.val(), 'YYYY-MM-DD');

            var window_index = 0;
            let day_index = 0;
            for ( ; day_index < numDays.val() ; day_index++) {
                let dateString = d.toISOString().slice(0, 10);

                let day_covered = false;
                for ( ; window_index < premiumPassData.availability_windows.length ; window_index++) {
                    let window = premiumPassData.availability_windows[window_index];

                    if (window.start_date > dateString) continue;
                    if (window.end_date < dateString) continue;

                    day_covered = true;
                    break;
                }

                if (!day_covered) break;

                d.add(1, 'days');
            }

            if (day_index != numDays.val()) {
                confirmationModal.foundation('open');
                $.unblockUI();
                return;
            }

            bookingForm.submit();
        };

        const forceSubmit = function(e) {
            e.preventDefault();

            bookingForm.submit();
        };

        confirmAddToCart.click(forceSubmit);
        addToCart.click(submitForm);

        const bookingCost = $('.wc-bookings-booking-cost');

        const setPriceContent = function(e) {
            $('.cost-container').html(bookingCost.html());
        }
        setPriceContent();
        let observer = new MutationObserver(setPriceContent);
        observer.observe(bookingCost[0], {characterData: true, childList: true});

        const costContainer = $('.cost-container');
        let ccObserver = new MutationObserver(maybeEnableAddToCart);
        ccObserver.observe(costContainer[0], {characterData: true, childList: true});

        guideName.change(maybeEnableAddToCart);
        partyName.change(maybeEnableAddToCart);

        // Blur and refocus as they type so change triggers immediately
        partyName.on('keyup', function() {
            $(this).blur();
            $(this).focus();
        });
        guestCategory.change(maybeEnableAddToCart);
        guestCategory.change(guestCategoryChange);
    });
})(jQuery);
